import { Map } from 'immutable';
import { Updater, AsyncState, loadedAsyncState, loadingAsyncState, unloadedAsyncState } from "widgets-for-react";
import { ImageSizesProps, ImageSourcesProps } from '../../../modernBlocks/modernBlocks.state';
import { Link } from "../../../utils/link";
import { PaginatedItem } from '../../../utils/pagination';
import { loadOverviewItems } from './overviewWidget.api';
import { ContentType } from '../searchPage/searchPage.state';

export type ParsedOverviewDetailItem = {
  Title: string
  Description: string
  Tags: string[]
  Link?: Link
  Kind: ContentType
  LastUpdated: string
  Created: string
} & ImageSizesProps


export type OverviewItemsCacheKeyName = string

export type OptionName = string

export type OptionValues = { value: string, isSelected: boolean }[]

export type OverviewState = {
  overviewItems: AsyncState<PaginatedItem<ParsedOverviewDetailItem>/* & Suggest*/>
  options: AsyncState<OverviewOptions>,
  overviewItemsCacheKeyName: OverviewItemsCacheKeyName,
  defaultPageSize: number,
  hideFilters?: boolean,
  optionalNotInUrlParameters: { key: string, value: string }[]
}

export type OverviewOptions = {
  items: Map<OptionName, OptionValues>
}

export let overviewUrlMap = Map<string, string>()
export let updateOverviewUrlMap = (k: string, v: string) => overviewUrlMap = overviewUrlMap.set(k, v)


export const initOverviewWidget = (firstCall: boolean,
  overviewItemsCacheKeyName: string,
  defaultPageSize?: number,
  optionalNotInUrlParameters?: { key: string, value: string }[], hideFilters?: boolean, options?: AsyncState<OverviewOptions>): OverviewState => {
  if (firstCall) {
    updateOverviewUrlMap(overviewItemsCacheKeyName, window.location.href)
  }

  let params = (new URL(window.location.href)).searchParams;

  defaultPageSize = defaultPageSize || 9
  let _pageSize = params.get('pageSize')
  if (_pageSize != undefined && _pageSize != "" && !isNaN(+_pageSize)) {
    defaultPageSize = +_pageSize
  }

  return {
    options: unloadedAsyncState(), //options || loadingAsyncState(() => loadOverviewOptions(overviewItemsCacheKeyName)),
    overviewItemsCacheKeyName,
    overviewItems: loadingAsyncState(() => loadOverviewItems(overviewItemsCacheKeyName, defaultPageSize!, optionalNotInUrlParameters)),
    defaultPageSize: defaultPageSize,
    hideFilters,
    optionalNotInUrlParameters: optionalNotInUrlParameters || []
  }
}

export function updateOverviewItemsOptions(setState: (_: Updater<OverviewState>) => void) {
  return (u: Updater<AsyncState<OverviewOptions>>) => setState(s => {
    return { ...s, options: u(s.options) }
  })
}

export function updateOverviewItems(setState: (_: Updater<OverviewState>) => void) {
  return (u: Updater<AsyncState<PaginatedItem<ParsedOverviewDetailItem>/* & Suggest*/>>) => setState(s => ({ ...s, overviewItems: u(s.overviewItems) }))
}


export function updateOverviewOptions(setState: (_: Updater<OverviewState>) => void): (output: Updater<OverviewOptions>) => void {
  return u => setState(s => ({
    ...s, options: s.options.kind == "loaded" ? loadedAsyncState(u(s.options.value)) : s.options
  }))
}

export function reloadOverviewItems(setState: (_: Updater<OverviewState>) => void) {
  setState(s => ({ ...s, overviewItems: loadingAsyncState(() => loadOverviewItems(s.overviewItemsCacheKeyName, s.defaultPageSize, s.optionalNotInUrlParameters)) }))
}
